import React from 'react'

import ExternalLink from '@/components/misc/ExternalLink'

interface Props {
  label: string
  className?: string
}

const TermsAndConditionsLink: React.FC<Props> = ({ label, className }) => {
  // You may need to purge the Cloudflare cache for both staging and production
  // if you update the contents of the file:
  // https://developers.cloudflare.com/cache/how-to/purge-cache/#purge-by-single-file-by-url
  const link = 'https://rq.app/terms-of-use'

  return (
    <ExternalLink href={link} className={className}>
      {label}
    </ExternalLink>
  )
}

export default TermsAndConditionsLink
